<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Jobs"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="name"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.name"
                  label="Nombre"
                  prepend-inner-icon="fas fa-number"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                      ref="icon" rules=""
                      v-slot="{ errors }"
              >
                <Upload
                        :error-messages="errors"
                        accept="image/png, image/jpeg, image/jpg"
                        placeholder="Icono"
                        prepend-icon="fas fa-camera"
                        label=""
                        :multiple="false"
                        :onSelectedPicture="onSelectedPicture"
                ></Upload>
                <v-img
                        :src="icon"
                        width="200"
                        style="margin: auto"
                ></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
          
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import Upload from "@/components/Upload";
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm, Upload},
    computed: {
      ...mapState({
        status: state => state.Jobs.status,
      })
    },
    methods: {
      onSelectedPicture(file) {
          const self = this;
          this.data.icon = file;

          let fr = new FileReader();
          fr.onload = function () {
              self.icon = fr.result;
          };
          fr.onerror = function () {
              self.icon = '';
          };
          fr.readAsDataURL(this.data.icon);
      }
    },
    data() {
      return {
        storeName: 'Jobs',
        title: "Trabajos",
        filteredAttributes: ["icon"],
        icon: "",
        data: {
          name: '',
          icon:undefined,
        }
      }
    }
  }
</script>
